
<div class="calendar-event w-border card shadow-sm rounded-3 mb-2">
  <div class="card-body">
    <!-- Header -->
    <div class="d-flex justify-content-end align-items-center mb-2">
      
      <div class="d-flex align-items-center">
        <button class="btn btn-link text-muted p-0 me-2" (click)="this.calendarStore.widgetGoToPreviousWeek()">
          <div class="mts-icon notranslate" translate="no">chevron_left</div>
        </button>
        <button class="btn btn-link text-muted p-0 me-1" (click)="this.calendarStore.widgetGoToNextWeek()">
          <div class="mts-icon notranslate" translate="no">chevron_right</div>
        </button>
        <div class="d-flex align-items-center gap-1">
          <app-icon-badge [style]="'default'" [icon]="'event'" [fontSize]="'fs-6'" [fontColor]="'text-muted'"></app-icon-badge>
          <app-content [fontSize]="'fs-default'">{{ calendarStore.widgetSchedulerMonth() }}</app-content>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-2">
      @for(day of calendarStore.widgetSchedulerEvents(); track day.date){
        <div
            class="text-center day-container"
            [class.current-day]="isToday(day.date)"
            (click)="onDayClicked(day)">
          <small [class.text-white]="isToday(day.date)"
                [class.text-muted]="!isToday(day.date)">
            {{ day.label }}
          </small>
  
          <div class="fw-bold py-1"
              [class.text-white]="isToday(day.date)"
              [class.rounded]="isToday(day.date)"
              [class.px-2]="isToday(day.date)">
            {{ day.day }}
          </div>
  
          <div class="dots-no-bg"
            [class.dots-container-inverted]="isToday(day.date) && day.eventDots.length > 0">
            @for(priority of day.eventDots; track $index) {
              <span
                  class="dot"
                  [class.bg-danger]="getDotClass(priority) === 'bg-danger'"
                  [class.bg-warning]="getDotClass(priority) === 'bg-warning'"
                  [class.bg-success]="getDotClass(priority) === 'bg-success'">
              </span>
            }
          </div>
        </div>
      }
    </div>

    <!-- Options Menu for Days of the Week -->
    <div class="d-flex justify-content-end">
      <div class="dropdown">
        <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
          <app-icon-badge [style]="'notification'" [icon]="'more_horiz'" [screenReaderText]="'SRMOREOPTIONS' | translate"></app-icon-badge>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li><app-link (click)="openNewEventDialog()" [title]="('CALADDEVENT' | translate)" [style]="'dropdown'">{{ ('CALADDEVENT' | translate) }}</app-link></li>
          <li><app-link (click)="onWeekViewClicked()" [title]="('CALSHOWALLEVENTS' | translate)" [style]="'dropdown'">{{ ('CALSHOWALLEVENTS' | translate) }}</app-link></li>
        </ul>
      </div>
    </div>

    <!-- Events -->
    <div class="upcoming-event-wrapper">
      @if(calendarStore.widgetUpcomingEvents().length > 0) {
        <app-item-calendar-event 
          [calenderEvent]="calendarStore.widgetUpcomingEvents()[0]" 
          (edit)="openEditEventDialog($event)"
          (details)="openEventDetailsDialog($event)">
        </app-item-calendar-event>
      } @else {
        <div class="d-flex flex-column align-items-center">
          <app-icon-badge [style]="'default'" [icon]="'event'" [fontSize]="'fs-4'" [fontColor]="'text-muted'"></app-icon-badge>
          <app-content [fontSize]="'fs-default'">{{ 'CALNOUPCOMINGEVENT' | translate }}</app-content>
        </div>
      }
    </div>
  </div>
</div>

@if(calendarEventDialog) {
  <app-dialog-calendar-event
    [(visible)]="calendarEventDialog" 
    [calendarEvent]="selectedEvent" 
    >
  </app-dialog-calendar-event>
}
@if(calendarEventDetailsDialog && selectedEvent){
  <app-dialog-calendar-event-details
    [visible]="calendarEventDetailsDialog"
    (visibleChange)="calendarEventDetailsDialog = $event"
    [calendarEvent]="selectedEvent"
    >
  </app-dialog-calendar-event-details>
}
